export const CANONICAL_FIRM_ID = 'default-firm';

export const resolveFirmId = (value: unknown): string => {
  const normalized = String(value ?? '').trim();
  return normalized || CANONICAL_FIRM_ID;
};

export const isCanonicalFirmId = (value: unknown): boolean => {
  return resolveFirmId(value) === CANONICAL_FIRM_ID;
};
